const getCurrentDomain = (): string => {
  const splitedHostname = window.location.hostname.split('.');
  const domainZone = splitedHostname[splitedHostname.length - 1];
  const domain = splitedHostname[splitedHostname.length - 2];

  return `${domain}.${domainZone}`;
};

export default getCurrentDomain;
